<template>
  <div>
    <div class="zj_nr_kk" v-if="examId == '' && questionId == ''">


      <!--筛选 str-->
      <div class="zj_sxtj" style="border: 1px solid #e3e3e3; overflow:hidden; margin-bottom:10px;">
        <div class="searchbox" id="basic_searchbox" style="border: none; height: 79px;">
          <div class="searchbox-item" data-id="0" id="searchitem_duixiang">
            <div class="l" id="searchitem_duixiang_l">学 期<i></i></div>
            <div class="c" id="searchitem_duixiang_c">
              <div class="control-type">(单选)</div>
              <div class="filter_option" style="padding-right:20px;">
                <span :class="{ selected: item.id == termId }" v-for="( item, index ) in  termList " :key="item.id"
                  @click="chooseTerm(item.id)">{{ item.name }}</span>

              </div>
            </div>
          </div>
          <div class="searchbox-item" style="border: 0" data-id="1" id="searchitem_duixiang">
            <div class="l" id="searchitem_duixiang_l">学 科<i></i></div>
            <div class="c" id="searchitem_duixiang_c">
              <div class="control-type">(单选)</div>
              <div class="filter_option" style="padding-right:20px;">
                <span title="不限" :class="{ option_all: true, selected: courseId == '' }"
                  @click="chooseCourse('')">不限</span>
                <span :class="{ selected: item.id == courseId }" v-for="( item, index ) in  courseList " :key="item.id"
                  @click="chooseCourse(item.id)">{{ item.name }}</span>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!--筛选 end-->

    </div>
    <div class="page_nrkk" style="margin-top:0px;" v-if="examId == '' && questionId == ''">

      <!--list str-->
      <div class="p_sclist">



        <!--1 str-->
        <div class="sc_xq " v-for="( item, index ) in  dataLi " :key="item.id">
          <div class="sx_tb"><span class="kslx">{{ showTypeName(item.type) }}</span></div>
          <div class="sx_bt">
            <div class="c1"><span>{{ item.name }}</span></div>

            <div class="c2"><span title="考试时间" class=""><i class="icon iconfont icon-gonggong-shijian"></i>{{
              timestampToTime(item.time) }}</span>

              <span title="科目"><i class="icon iconfont icon-zhishi"></i>{{ item.courseName }}</span>
            </div>

          </div>

          <div class="sx_bn">
            <span class="bn1" @click="goReport(item)">扫码查看报告</span>
            <span class="bn2" @click="openReportBox(item)">生成PDF报告</span><span class="bn2"
              @click="goCtb(item.id, item.userId, item.classId)">生成错题本</span>
          </div>
        </div>
        <!--1 end-->

        <div class="pc_nosj"  v-if="dataLi.length==0">
              <i class="icon iconfont icon-wushuju"></i>
              <span class="wz">当前未查询到考试报告/错题本</span>
            </div>




      </div>
      <!--list end-->







      <el-dialog title="生成PDF报告" :visible.sync="reportBox" width="280px" class="layui-layer-dialog">
        <div id="" class="layui-layer-content">
          <div class="tc_xzxx">
            <ul>
              <li v-for="( item, index ) in  examCourseList " :key="item.id"><label><input type="checkbox"
                    @click="handleCourse(item.id)" class="sz_checkbox"
                    :checked="chooseCourseId.indexOf(item.id) != -1 ? true : false">{{ item.name }}</label></li>

            </ul>
          </div>
        </div>
        <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0" @click="confirmCourse(0)">确定</a></div>
      </el-dialog>


    </div>



    <div class="zj_nr_kk" v-if="examId">


      <!--筛选 str-->
      <div class="zj_sxtj" style="border: 1px solid #e3e3e3; overflow:hidden; margin-bottom:10px;">
        <div class="searchbox" id="basic_searchbox" style="border: none; height: 117px;">
          <div class="searchbox-item" data-id="0" id="searchitem_duixiang">
            <div class="l" id="searchitem_duixiang_l">科 目<i></i></div>
            <div class="c" id="searchitem_duixiang_c">
              <div class="control-type">(单选)</div>
              <div class="filter_option" style="padding-right:20px;">
                <div style="display: inline-block;width: 60px;" v-for="( item, index ) in  courseList " :key="item.id">
                  <span v-if="item.realCourse" :class="{ selected: chooseId == item.id }"
                    @click="chooseCourse(item.realCourse, item.id)">{{ item.name }}</span>
                  <span v-else="item.realCourse" :class="{ selected: chooseId == item.id }"
                    @click="chooseCourse(item.id)">{{ item.name }}</span>
                </div>



              </div>
            </div>
          </div>
          <div class="searchbox-item" data-id="1" id="searchitem_duixiang">
            <div class="l" id="searchitem_duixiang_l">题 型<i></i></div>
            <div class="c" id="searchitem_duixiang_c">
              <div class="control-type">(多选)</div>
              <div class="filter_option" style="padding-right:20px;">
                <span title="不限" :class="{ option_all: true, selected: questionTypeIdStr.length == 0 }"
                  @click="chooseQuestionType()">不限</span>
                <span :class="{ selected: questionTypeIdStr.indexOf(item.id) != -1 }"
                  v-for="( item, index ) in  questionTypeList " :key="item.id" @click="chooseQuestionType(item.id)">{{
                    item.name }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="searchbox-item" data-id="2" id="searchitem_duixiang">
            <div class="l" id="searchitem_duixiang_l">难 度<i></i></div>
            <div class="c" id="searchitem_duixiang_c">
              <div class="control-type">(多选)</div>
              <div class="filter_option" style="padding-right:20px;"><span title="不限"
                  class="option_all selected">不限</span><span title="易" data-id="0" data-value="0">易</span><span title="较易"
                  data-id="1" data-value="1">较易</span><span title="中档" data-id="2" data-value="1">中档</span><span
                  title="较难" data-id="3" data-value="1">较难</span><span title="难" data-id="4" data-value="1">难</span></div>
            </div>
          </div> -->
          <div class="searchbox-item" style="border: 0" data-id="3" id="searchitem_duixiang">
            <div class="l" id="searchitem_duixiang_l">属 性<i></i></div>
            <div class="c" id="searchitem_duixiang_c">
              <div class="control-type">(单选)</div>
              <div class="filter_option" style="padding-right:20px;">
                <span title="只显示错题" :class="{ selected: !allQues }" @click="chooseAllQues(false)">只显示错题</span>
                <span title="整卷试题" :class="{ selected: allQues }" @click="chooseAllQues(true)">整卷试题</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--筛选 end-->



      <!--left str-->

      <!--left end-->
      <!--right str-->
      <div class="zj_nr_right" style="width:1200px;">


        <!--list str-->
        <div class="ks_list_kk">

          <div class="ks_name_01"><span>{{ findExam.name }}</span></div>

          <div class="jj10"></div>



          <!--kjdh str-->
          <div class="zj_btxx">

            <span class="d_left">查询结果<em>共查询到<span>{{ questionList.length }}</span>道试题</em>
              <span class="yxtx" v-if="questionTypeIdStr.length">已选题型：{{ questionTypeName }}</span>
              <!-- <span class="yxtx">难度：易</span> -->
            </span>
            <span class="d_right">
              <i class="icon iconfont icon-duoxuankuang2" v-if="allChoose" @click="handleAllChoose(false)"></i>
              <i class="icon iconfont icon-kuang" v-if="!allChoose" @click="handleAllChoose(true)"></i>
              全选({{ chooseQuestionList.length }}/{{ questionList.length }})</span>
          </div>
          <!--kjdh end-->

          <!--ti list str-->
          <div class="zj_kk" v-if="questionList.length">

            <!--1 str-->
            <div class="zj_ti_kk" v-for="( item, index ) in  questionList " :key="index">

              <!--tg str-->
              <div class="sj_yl_ti_nr01">

                <div class="serial-number">{{ index + 1 }} 、第{{ item.no }}题</div>

                <span class="xzst">
                  <i class="icon iconfont icon-duoxuankuang2" v-if="chooseQuestionList.indexOf(item.id) != -1"
                    @click="chooseQuestion(item.id)"></i>
                  <i class="icon iconfont icon-kuang" v-if="chooseQuestionList.indexOf(item.id) == -1"
                    @click="chooseQuestion(item.id)"></i>
                </span>

                <div class="ct_ti_xx" style="padding:0px;" v-if="item.cont">

                  <div class="nr" v-html="item.cont"></div>
                </div>
              </div>
              <!--tg end-->


              <div class="zj_ti_sx">
                <span class="s_left">

                  <span>我的得分率:<font>{{ ((item.scoreRate) * 100).toFixed() }}%</font></span>
                </span>

                <span class="s_right">

                  <span id="jx_bn" class="btjx" @click="goXq(item.questionId)"><i
                      class="icon iconfont icon-wenzhang1"></i>试题详情</span>



                  <button type="button" class="btn btn-info" style="z-index:100;"
                    v-if="chooseQuestionList.indexOf(item.id) != -1" @click="chooseQuestion(item.id)"><i
                      class="icon iconfont icon-wenzhang1 "></i>取消选择</button>

                  <button type="button" class="btn btn-success shiti_add" style="z-index:100;"
                    v-if="chooseQuestionList.indexOf(item.id) == -1" @click="chooseQuestion(item.id)"><i
                      class="icon iconfont icon-wenzhang1"></i>选择此题</button>

                </span>

              </div>

            </div>
            <!--1 end-->




            <!--fy str-->
            <div class="center" style=" text-align:center;">
              <!-- <img src="images/test/ym.png"> -->
            </div>
            <!--fy end-->
            <!---无数据提示 str-->

            <!---无数据提示 end-->

          </div>
          <div class="pc_nosj" v-if="questionList.length==0">
        <i class="icon iconfont icon-wushuju"></i>
        <span class="wz">当前未查询到相关试题</span>
      </div>


          <!--ti list end-->


        </div>
        <!--list end-->


      </div>
   
      <!--right end-->
    </div>
    <div class="zj_p_caozuo" v-if="examId">
      <ul>
        <li class="c1 go-top" style="display: list-item;" @click="gotop" v-if="showHandleTop"><i
            class="icon iconfont icon-zhiding" title="点击回到顶部"></i><span class="sm">回顶部</span></li>
        <li class="c2" @click="showCtbBox" title="点击预览试题"><span class="num"><em>{{ chooseQuestionList.length
        }}</em></span><span class="sm">已选题</span></li>
      </ul>
    </div>

    <el-dialog title="设置错题本名称" :visible.sync="ctbBox" width="500px" class="layui-layer-dialog ctbBox">
      <div id="" class="layui-layer-content">
        <div class="tc_ma">
          <input type="text" class="wbk_serach01" id="name" placeholder="设置名称" v-model="ctbName">
        </div>

        <div class="dy_site_kk">
          <label :class="{ active: shiti }"><input type="checkbox" v-model="shiti" name="orderType1"
              class="sz_checkbox">试题
          </label>
          <label :class="{ active: daan }"><input type="checkbox" v-model="daan" name="orderType1"
              class="sz_checkbox">答案</label>
        </div>
      </div>
      <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0" @click="confirmCtb">确认</a><a
          class="layui-layer-btn1" @click="ctbBox = false">取消</a>
      </div>
    </el-dialog>
 




    <div class="zj_nr_kk" v-if="questionId">
      <div class="zj_nr_left">
        <div class="zj_gg_ys" @click="goIndex">
          <img src="https://www.360ping.com/images/gg.jpg" alt="" />
        </div>
      </div>
      <div class="zj_nr_right">
        <div class="ks_list_kk">
          <div class="zj_kk">
            <div class="zj_ti_kk zj_box">
              <div class="sj_yl_ti_nr01" v-if="paperData != null">
                <!-- <span>{{ item.no }}.</span> -->
                <span class="nr" v-html="paperData.content"></span>
              </div>
              <div class="sj_xq_ti_jx" style="margin-bottom: 20px" v-if="paperData != null">
                <ul v-if="paperDetail.knowledge.length || paperData.KnowledgePoint">
                  <li class="j_left">【知识点】</li>
                  <li class="j_right lan">
                    <div>
                      <div v-if="paperData.KnowledgePoint" class="zj_zsd_list">
                        <span v-for="( item, index ) in  paperData.KnowledgePoint " :key="item.id + index"
                          style="margin-right: 20px">{{ item.name }}</span>
                      </div>
                      <div v-for=" item  in  paperData.questionAnswer " :key="item.id">
                        <div v-if="item.questionAnswerKnowledgePointList &&
                          item.questionAnswerKnowledgePointList.length > 0
                          " class="stxq_ys01">
                          <span class="tihao">{{ item.smallNo }}</span>
                          <span v-for="(
                               tmp, tmpIndex 
                            ) in  item.questionAnswerKnowledgePointList " :key="tmp.id">
                            {{ tmp.name
                            }}<span v-if="tmpIndex <item.questionAnswerKnowledgePointList.length - 1 ">、</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-else class="red">未录入</div> -->
                    <!-- <div v-else style="color: #f00">未录入</div> -->
                  </li>
                </ul>
                <ul v-if="paperDetail.answer">
                  <li class="j_left">【答案】</li>
                  <li class="j_right da">
                    <div v-for="( item, index ) in  paperData.questionAnswer " :key="index" class="stxq_ys01">
                      <span class="tihao" v-if="item.smallNo">{{
                        item.smallNo
                      }}</span>
                      <span v-if="item.questionTypeId == 1 || item.questionTypeId == 2
                          ">
                        <span>{{ letterFilter(item.answer) }}</span>
                      </span>
                      <span v-else-if="item.questionTypeId == 3">
                        {{ item.answer == 1 ? "正确" : "错误" }}
                      </span>
                      <span v-else class="nr" v-html="item.answer"></span>
                    </div>
                  </li>
                  <!-- <li class="j_right da" v-if="paperData.questionTypeId == 1 || paperData.questionTypeId ==2 ">
              <div v-for="(item,index) in paperData.questionAnswer" :key="index">
                <div>{{letterFilter(item.answer)}}</div>
              </div>
            </li>
            <li class="j_right da" v-else-if="paperData.questionTypeId == 3">
              {{paperDetail.answer==1?'正确':'错误'}}
            </li>
            <li class="j_right da" v-else v-html="paperDetail.answer"></li> -->
                </ul>
                <ul v-if="paperDetail.fenXi || paperData.fenXi">
                  <li class="j_left">【分析】</li>
                  <li class="j_right">
                    <div>
                      <div v-html="paperData.fenXi"></div>
                      <div v-if="paperDetail.fenXi">
                        <div v-for=" item  in  paperData.questionAnswer " :key="item.id" class="stxq_ys01">
                          <div v-if="item.fenXi">
                            <span class="tihao" v-if="item.smallNo">{{
                              item.smallNo
                            }}</span>
                            <span class="nr" v-html="item.fenXi"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-else class="red">未录入</div> -->
                  </li>
                </ul>
                <!-- 【解答】 -->
                <ul v-if="paperDetail.analysis">
                  <li class="j_left">【详解】</li>
                  <li class="j_right">
                    <div v-if="paperDetail.analysis">
                      <div v-if="paperDetail.analysis">
                        <div v-for=" item  in  paperData.questionAnswer " :key="item.id" class="stxq_ys01">
                          <div v-if="item.analysis">
                            <span class="tihao" v-if="item.smallNo">{{
                              item.smallNo
                            }}</span>
                            <span class="nr" v-html="item.analysis"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-else class="red">未录入</div> -->
                  </li>
                  <!-- <li class="j_right" v-html="paperDetail.analysis"></li> -->
                </ul>
                <ul v-if="paperDetail.comment || paperData.comment">
                  <li class="j_left">【点评】</li>
                  <li class="j_right">
                    <div>
                      <div v-html="paperData.comment"></div>
                      <div v-for=" item  in  paperData.questionAnswer " :key="item.id" class="stxq_ys01">
                        <div v-if="item.comment">
                          <span class="tihao" v-if="item.smallNo">{{
                            item.smallNo
                          }}</span>
                          <span class="nr" v-html="item.comment"></span>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-else class="red">未录入</div> -->
                  </li>
                </ul>
              </div>
              <div class="zj_ti_sx" v-if="paperData != null">
                <span class="s_left">
                  <span>难度：
                    <font>
                      {{ paperData.difficultyCoefficient == undefined ? '0' : paperData.difficultyCoefficient }}
                    </font>
                  </span>
                  <span>收录： <font>{{ paperData.ct_time }}</font></span>
                </span>
                <!-- <span class="s_right">
                  
                  <button type="button" class="btn btn-default">
                    <i class="fa fa-star-o"></i>
                    收藏此题
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    class="btn btn-success shiti_add"
                    style="z-index: 100"
                  >
                    <i class="fa fa-file-text-o"></i>
                    加入试卷
                  </button>
                </span> -->
              </div>
            </div>
          </div>
        </div>
     
      </div>
    
    </div>


    <el-dialog title="开通VIP开通全部功能" :visible.sync="codeVisible" class="layui-layer-dialog" width="280px" v-if="ifVip != 1">
      <div id="" class="layui-layer-content">
        <div class="tc_ma">
          <img src="https://www.360ping.com/images/wx/loding.gif" style="transform: scale(0.1);" v-show="!isImg">
          <img :src="'data:image/png;base64,' + codeImg" v-show="isImg">
          <span><i class="icon iconfont icon-weixin2"></i>微信扫码</span><span class="zt_red">在手机端开通VIP后，使用全部功能</span>
        </div>
      </div>
      <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0" @click="codeVisible = false">确认</a>
      </div>
    </el-dialog>

    <el-dialog title="扫码查看" :visible.sync="vipVisible" class="layui-layer-dialog" width="280px" v-if="ifVip == 1">
      <div id="" class="layui-layer-content">
        <div class="tc_ma">
          <img src="https://www.360ping.com/images/wx/loding.gif" style="transform: scale(0.1);" v-show="!isImg">
          <img :src="'data:image/png;base64,' + codeImg" v-show="isImg">
          <span><i class="icon iconfont icon-weixin2"></i>微信扫码查看</span>
        </div>
      </div>
      <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0" @click="vipVisible = false">确认</a>
      </div>
    </el-dialog>

    <!--遮罩层-->
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <p class="loading-text">加载中...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { queryCourse, queryTermList, queryStuExam, getAllExamType, addReport, queryExamById, queryExamCourseNew, queryQuestionType, queryStuWrongQuestionsExam, queryQuestionByQuestionId, queryQrCode } from "../api/request";
export default {
  components: {},
  props: {},
  data() {
    return {
      shiti: true,
      daan: true,
      ctbName: '',
      ctbBox: false,
      showHandleTop: false,
      allChoose: false,
      examId: '',
      reportBox: false,
      termList: [],
      termId: '',
      courseList: [],
      courseId: '',
      showData: false,
      dataLi: [],
      examTypeList: [],
      examCourseList: [],
      chooseCourseId: [],
      activeData: {},
      findExam: {},
      questionTypeIdStr: [],
      questionTypeList: [],
      allQues: false,
      questionList: [],
      questionTypeName: '',
      chooseQuestionList: [],
      questionId: '',
      paperData: null,
      ifVip: 1,
      codeImg: '',
      loading: false,
      codeVisible: false,
      vipVisible: false,
      splitCourseIdArr: [],
      paperDetail: {
        fenXi: "",
        answer: "",
        analysis: "",
        comment: "",
        content: "",
        title: [],
        knowledge: [],

      },
      boxloading: false,
      url: '',
      isLoading: true,
      isImg: false,
      chooseId: '',
      
    };
  },
  watch: {},
  computed: {},
  methods: {
    goIndex() {
      this.$router.push('/')
    },
    goXq(questionId) {
      window.open('/qjyxWeb-user/examinationReport?questionId=' + questionId);
    },
    confirmCtb() {
      let courseName = '';
      this.courseList.map((item) => {
        if (item.id == this.courseId) {
          courseName = item.name;
        }
      })
      let splitCourse = false;
      this.splitCourseIdArr.map((item) => {
        if (item.id == this.courseId) {
          splitCourse = true;
        }
      })
      // console.log(this.findExam,'oooooo');
      let addData = {
        fggExamId: this.examId,
        fggCourseId: this.courseId,
        stuId: sessionStorage.getItem('stuid'),
        fggClassId: this.$route.query.classId,
        reportSendId: 0,
        type: 1,
        fggExamName: this.findExam.name,
        fggCourseName: courseName,
        fggExamType: this.findExam.examTypeName,
        fggAnswerCardQuestionIdString: this.chooseQuestionList.toString(),
        info: JSON.stringify({
          hideQRcode: 1,
          wrong: this.shiti ? 1 : 0,
          answer: this.daan ? 1 : 0,
          fullScore: 0,
          score: 0,
          classAvg: 0,
          gradeAvg: 0,
          recommend: 0,
          recommendAnswer: 0,
          splitCourse: splitCourse,
          answerCardQuestionIdStr: this.chooseQuestionList.toString(),
          allQues: this.allQues
        })
      };
      addReport(addData).then((res) => {
        if (res.data.code == 200 && res.data.data) {

          this.$message({
            showClose: true,
            message: '已提交到后台生成中，可在"生成记录"里查看进度',
            type: 'success'
          });
          this.ctbBox = false;
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        }
      })
    },
    showCtbBox() {

      if (this.chooseQuestionList.length) {

        var date = new Date();
        var Y = date.getFullYear();
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1);
        var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
        this.ctbName = `${this.findExam.name}-错题本${Y}${M}${D}`
        this.ctbBox = true;
      } else {
        this.$message({
          showClose: true,
          message: '请先选择试题！',
          type: 'error'
        });
      }
    },
    handleAllChoose(type) {
      this.allChoose = type;
      this.chooseQuestionList = [];
      if (type) {
        this.questionList.map((item) => {
          this.chooseQuestionList.push(item.id);
        })
      }
    },
    chooseQuestion(id) {
      if (this.chooseQuestionList.indexOf(id) != -1) {
        this.chooseQuestionList.splice(this.chooseQuestionList.indexOf(id), 1)
      } else {
        this.chooseQuestionList.push(id);
      }
      this.allChoose = this.chooseQuestionList.length == this.questionList.length;
    },
    chooseAllQues(type) {
      this.allQues = type;
      this.getData()
    },
    chooseQuestionType(id) {
      if (id == undefined) {
        this.questionTypeIdStr = [];
      } else {
        if (this.questionTypeIdStr.indexOf(id) != -1) {
          this.questionTypeIdStr.splice(this.questionTypeIdStr.indexOf(id), 1)
        } else {
          this.questionTypeIdStr.push(id)
        }
      }
      let nameArr = [];
      for (let i = 0; i < this.questionTypeList.length; i++) {
        this.questionTypeIdStr.map((item) => {
          if (this.questionTypeList[i].id == item) {
            nameArr.push(this.questionTypeList[i].name);
          }
        })
      }

      this.questionTypeName = nameArr.join(',')
      this.getData()
    },

    goCtb(id, uid, classId) {
      if (this.ifVip == 0) {
        this.codeVisible = true;
        this.loading = true;

        queryQrCode({ url: 'https://www.360ping.com/mp?p=2' }).then((res) => {
          if (res.data.code == 200) {

            this.codeImg = res.data.data;
            this.loading = false;

          }
        })
        return
      }
      window.open('/qjyxWeb-user/examinationReport?examId=' + id + '&stuUserId=' + uid + '&classId=' + classId);
      // const urlParams = new URLSearchParams(window.location.search);
      // const hasId = urlParams.get('id');

      // if (hasId) {
      //   // const baseUrl = new URL(window.location.href);
      //   // baseUrl.search = '';

      //   // window.location.href = baseUrl.href;
      //   this.url='/qjyxWeb-user/examinationReport'
      // } else {
      //   this.url='/qjyxWeb-user/examinationReport?examId=' + id + '&stuUserId=' + uid + '&classId=' + classId

      // }
      // window.open(this.url)


    },
    confirmAddReport(index) {

      if (this.chooseCourseId.length == index) {
        return
      }
      let courseName = '';
      this.courseList.map((item) => {
        if (item.id == this.chooseCourseId[index]) {
          courseName = item.name;
        }
      })
      let splitCourse = false;
      if (this.activeData.splitCourse) {
        if (this.activeData.splitCourse.indexOf(this.chooseCourseId[index]) != -1) {
          splitCourse = true;
        }
      }


      let addData = {
        fggExamId: this.activeData.id,
        fggCourseId: this.chooseCourseId[index],
        stuId: sessionStorage.getItem('stuid'),
        fggClassId: this.activeData.classId,
        reportSendId: 0,
        type: 2,
        fggExamName: this.activeData.name,
        fggCourseName: courseName,
        fggExamType: this.activeData.examTypeName,
        info: JSON.stringify({
          hideQRcode: 1,
          splitCourse: splitCourse,
          report: 1,
          wrong: 1,
          wrongAnswer: 1,
          recommend: 1,
          recommendAnswer: 1,
        })
      };
      addReport(addData).then((res) => {
        if (res.data.code == 200) {
          index++;
          this.confirmAddReport(index)
        }
      })
    },
    confirmCourse() {
      if (this.chooseCourseId.length == 0) {
        this.$message({
          showClose: true,
          message: "请先选择科目",
          type: 'error'
        });
        return
      } else {
        this.$message({
          showClose: true,
          message: "报告生成中..",
          type: 'success'
        });
        this.confirmAddReport(0);
        this.reportBox = false;
        return
      }
    },
    handleCourse(id) {
      if (this.chooseCourseId.indexOf(id) != -1) {
        this.chooseCourseId.splice(this.chooseCourseId.indexOf(id), 1)
      } else {
        this.chooseCourseId.push(id)
      }
    },
    goReport(data) {
      this.isImg = false
      this.vipVisible = true;
      this.loading = true;
      this.codeVisible = true;
      this.loading = true;
      if (this.ifVip == 1) {


        queryQrCode({ url: `https://www.360ping.com/mp?p=6&examId=${data.id}&course=${data.courseId.split(',').length > 1 ? 0 : data.courseId.split(',')[0]}&stuUserId=${data.userId}&oldReport=1` }).then((res) => {
          if (res.data.code == 200) {
            this.isImg = true
            this.codeImg = res.data.data;
            this.loading = false;
          }
        })
        return
      }


      queryQrCode({ url: 'https://www.360ping.com/mp?p=2' }).then((res) => {
        if (res.data.code == 200) {
          this.isImg = true
          this.codeImg = res.data.data;
          this.loading = false;
        }
      })



    },
    openReportBox(data) {
      if (this.ifVip == 0) {
        this.codeVisible = true;
        this.loading = true;
        queryQrCode({ url: 'https://www.360ping.com/mp?p=2' }).then((res) => {
          if (res.data.code == 200) {

            this.codeImg = res.data.data;
            this.loading = false;
          }
        })
        return
      }
      this.activeData = data;
      let arr = data.haveScoreCourseIdStr.split(',');
      let courseIdList = [];
      this.chooseCourseId = [];
      for (let i = 0; i < arr.length; i++) {
        let obj = { id: arr[i] }
        this.courseList.map((item) => {
          if (item.id == arr[i]) {
            obj.name = item.name;
          }
        })
        courseIdList.push(obj);
        this.chooseCourseId.push(arr[i]);
      }
      this.examCourseList = courseIdList;
      this.reportBox = true;
    },
    timestampToTime(timestamp) {
      // 时间戳为10位需*1000，时间戳为13位不需乘1000
      var date = new Date(timestamp);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D;
    },
    showTypeName(id) {
      let name = '';
      this.examTypeList.map((item) => {
        if (item.id == id) {
          name = item.name;
        }
      })
      return name;
    },
    getData() {
      this.isLoading = true
      this.boxloading = true;
      this.showData = false;
      if (this.examId) {
        queryStuWrongQuestionsExam({ examIdStr: this.examId, course: this.courseId, stuUserId: this.$route.query.stuUserId, sortType: 3, questionTypeIdStr: this.questionTypeIdStr.toString(), allQues: this.allQues }).then((res) => {
          if (res.data.code == 200) {
            let dataArr = res.data.data.stuWrongQuestions;
            dataArr.map((item) => {


              if (item.isQues == "true") {
                if (item.questionTypeId == 1 || item.questionTypeId == 2 || item.questionTypeId == 3 || item.questionTypeId == 5) {
                  let cont = JSON.parse(item.content);
                  let str = ''
                  for (let i = 0; i < cont.length; i++) {
                    str += cont[i].text;
                  }
                  item.cont = str;
                } else if (item.questionTypeId == 4) {
                  let cont = JSON.parse(item.content);
                  let str = ''
                  for (let i = 0; i < cont.length; i++) {
                    str += cont[i].title;
                  }
                  item.cont = str;
                } else {
                  item.cont = item.content;
                }
              } else {
                item.cont = item.content;
              }
            })
            this.questionList = dataArr;
          } else {
            this.questionList = [];
          }
          this.showData = true;
          this.boxloading = false;
          this.isLoading = false
        })

      } else {
        let searchData = { termId: this.termId, pageNum: 1, pageSize: 9999999, isWork: false };
        if (this.courseId) {
          searchData.courseIdStr = this.courseId;
        }

        queryStuExam(searchData).then((res) => {
          if (res.data.code == 200) {
            this.dataLi = res.data.data
            console.log(this.dataLi, 'this.dataLi')
          } else {
            this.dataLi = []
          }
          this.showData = true;
          this.isLoading = false
        })

        setTimeout(() => {
          // 请求完成后停止加载动画
          this.isLoading = false;
        }, 2000);
      }

    },
    chooseCourse(id, realId) {

      this.chooseQuestionList = [];
      this.chooseId = id
      this.courseId = id;
      if (realId) {
        id

        this.chooseId = realId
      }
      // this.getData();
      this.getExamType()
    },
    chooseTerm(id) {
      this.termId = id;
      this.getCourse()
    },
    getCourse() {
      // this.isLoading = true
      let seachData = { termId: this.termId, examFlag: true };
      queryCourse(seachData).then((res) => {
        if (res.data.code == 200) {
          this.courseList = res.data.data;
          this.courseId = '';
          this.chooseCourseName = this.courseList[0].name;
          this.getExamType()
          // this.getData();
        } else if (res.data.code == 300) {
          this.isLoading = false
        }

        setTimeout(() => {
          // 请求完成后停止加载动画
          this.isLoading = false;
        }, 15000);
      })
    },
    getExamCourse() {
      this.splitCourseIdArr = [];
      queryExamCourseNew({ examId: this.examId, stuUserId: this.$route.query.stuUserId }).then((res) => {
        if (res.data.code == 200) {
          let courseArr = res.data.data;
          let newArr = [];
          let newsplitArr = [];
          courseArr.map((item) => {
            if (item.name == '理综' || item.name == '文综') {
              newArr.push(...item.courseList)
              newsplitArr.push(...item.courseList)
            } else {
              newArr.push(item)
            }

          })
          this.splitCourseIdArr = newsplitArr;
          this.courseList = newArr;
          this.courseId = this.courseList[0].id;
          this.chooseId = this.courseList[0].id;

          this.getExamType();
        }
      })
    },
    getExamType() {
      queryQuestionType({ course: this.courseId, examId: this.examId }).then((res) => {
        if (res.data.code == 200) {
          this.questionTypeList = res.data.data;
          this.getData();
        }
      })
    },
    // 获取页面滚动距离
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log(scrollTop, '滚动距离')
      this.showHandleTop = scrollTop > 1300;
    },
    gotop() {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      })
    },
    getTime(time) {
      let strDate = '';
      var date = new Date(time);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

      strDate = Y + M + D;
      return strDate;

    },
    letterFilter(index) {
      const letter = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
      ];
      if (typeof index == "number") {
        return letter[index];
      } else if (typeof index == "string") {
        if (index.indexOf(",") !== -1) {
          index = index.split(",");
          let str = "";
          index.forEach((item) => {
            str += letter[item - 1];
          });
          return str;
        } else {
          index = index * 1;
          return letter[index - 1];
        }
      } else {
        let str = "";
        index.forEach((item) => {
          str += letter[item - 1];
        });
        return str;
      }
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery, oldQuery) {
        // console.log('地址栏参数发生变化', newQuery);
        if (!newQuery.examId) {
          this.examId = ''
          this.questionId = ''
          queryTermList({ haveScoreFlag: true }).then((res) => {
            if (res.data.code == 200) {
              this.termList = res.data.data;
              this.termId = this.termList[0].id;
              this.getCourse()
            }
          })
          getAllExamType().then((res) => {
            if (res.data.code == 200) {
              this.examTypeList = res.data.data.data;
            }
          })
        }
      }
    }
  },
  created() { },
  mounted() {


    this.ifVip = sessionStorage.getItem('ifVip')
    if (this.$route.query.examId) {
      this.examId = this.$route.query.examId;
      queryExamById(this.examId).then((res) => {
        if (res.data.code == 200) {
          this.findExam = res.data.data;
          this.getExamCourse();
        }
      })
      window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    } else if (this.$route.query.questionId) {
      this.questionId = this.$route.query.questionId;

      queryQuestionByQuestionId({ questionId: this.questionId }).then((res) => {
        if (res.data.code == 200 && res.data.data) {
          this.paperData = res.data.data;
          console.log(this.paperData,456);

          this.paperData.ct_time = this.getTime(this.paperData.createTime)

          if (this.paperData.questionAnswer) {
            this.paperData.questionAnswer.forEach((item, index) => {
              // if(item.content){
              //   this.paperData.content += item.content
              // }
              item.content1 = "";
              if (item.questionAnswerKnowledgePointTagList) {
                item.questionAnswerKnowledgePointTagList.forEach((subItem) => {
                  this.paperDetail.title.push(subItem.name);
                });
              }
              if (item.questionAnswerKnowledgePointList) {
                item.questionAnswerKnowledgePointList.forEach((subItem) => {
                  this.paperDetail.knowledge.push(subItem.name);
                });
              }
              if (item.answerSelect) {
                // this.answerSelect.push(item.answerSelect)
                // item.answerSelect.forEach((subItem,index)=>{
                //   item.content1 += `<div style="display: flex;">${this.letterFilter(index)}.${subItem.content}</div>`
                // })
              }
              this.paperDetail.answer += item.answer ? `${item.answer}` : "";
              this.paperDetail.fenXi += item.fenXi ? `${item.fenXi}` : "";
              this.paperDetail.analysis += item.analysis
                ? `${item.analysis}`
                : "";
              this.paperDetail.comment += item.comment ? `${item.comment}` : "";
            });
          }
          this.paperDetail.title = [...new Set(this.paperDetail.title)];
        } else if (res.data.code == 200 && !res.data.data) {
          this.$message({
            showClose: true,
            message: '未查到相关数据。',
            type: 'error'
          });
        }
      })
    } else {
      queryTermList({ haveScoreFlag: true }).then((res) => {
        if (res.data.code == 200) {
          this.termList = res.data.data;
          this.termId = this.termList[0].id;
          this.getCourse()
        }
      })
      getAllExamType().then((res) => {
        if (res.data.code == 200) {
          this.examTypeList = res.data.data.data;
        }
      })
    }

  }
};
</script>
<style lang="less" scoped>
@import url("../assets/layer.css");
@import url("../assets/public_style.css");
@import url("../assets/pc_style.css");
@import url("../assets/ctb_style.css");
@import url("../assets/filterMore.min.css");
@import url("../assets/previewPaper.css");



.zj_zsd_list span {
  background-color: #09f;
  color: #fff;
  border-radius: 10px;
  margin-right: 6px;
  margin-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.red {
  color: #dd4b39;
}

.sj_xq_ti_jx {
  font-size: 14px;
}

.sj_xq_ti_jx ul {
  display: block;
  clear: both;
  padding-left: 0px;
  position: relative;
}

.zj_gg_ys img {
  width: 100%;
}

.zj_gg_ys {
  display: block;
  clear: both;
}

.zj_nr_left {
  float: left;
  width: 280px;
  background-color: #fff;
  border: 1px solid #bde7e0;
}

.zj_nr_kk {
  width: 1200px;
  margin: 0px auto;
  margin-top: 10px;
  overflow: hidden;
}

.zj_xx_dh span {
  color: #09f;
}

.zj_xx_dh {
  width: 1200px;
  background-color: #fff;
  margin: 0px auto;
  padding: 10px 10px 10px 10px;
  border-bottom: 1px solid #efefef;
}

.big_box {
  background-color: #f8f8f8;
}


.zj_ti_jx {
  display: block;
  clear: both;
  overflow: hidden;
  border: #1abb9c 0px solid;
  position: relative;
}

.zj_ti_jx ul {
  display: block;
  clear: both;
}

.zj_ti_jx ul li.j_left {
  width: 15%;
  float: left;
  line-height: 30px;
  text-align: right;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #222;
  font-weight: bold;
}

.zj_ti_jx ul li.j_right {
  width: 83%;
  float: right;
  line-height: 30px;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 5px;
}

.zj_ti_jx ul li.da {
  color: #009900;
}


.zj_nr_left {
  width: 280px;
}

.zj_nr_right {
  width: 910px;
}

// /deep/.ctbBox .el-dialog__body{
//   height:600px
// }
.dy_site_kk {
  display: block;
  clear: both;
  position: relative;
  padding: 20px;
  line-height: 24px;
  word-break: break-all;
  overflow: hidden;
  font-size: 14px;
  overflow-x: hidden;
  overflow-y: auto;
}

.dy_site_kk label {
  background-color: #ebf7f6;
  border: 1px solid #ccc;
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px 10px 5px 10px;
  border-radius: 3px;
  font-size: 14px;
  margin-bottom: 10px;
  display: inline-block;
  min-width: 90px;
}

.dy_site_kk label .sz_checkbox {
  vertical-align: middle !important;
  margin-top: -2px !important;
  margin-bottom: 1px !important;
}

.dy_site_kk label input {
  margin-right: 3px !important;
  -webkit-appearance: checkbox;
}

.dy_site_kk .active {
  background-color: #4fbaa0;
  border: 1px solid #4fbaa0;
  color: #fff;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.btn-info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}

.btn-success {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
}



.zj_p_caozuo {
  position: fixed;
  right: 10px;
  bottom: 80px;
  z-index: 1000;
}

.zj_p_caozuo ul li {
  width: 60px;
  height: 60px;
  text-align: center;
  border-radius: 50%;
  background-color: #fff;
  background: rgba(255, 255, 255, 0.85);
  margin-bottom: 10px;
  line-height: 48px;
  border: 1px solid #dfdfdf;
  position: relative;
  cursor: pointer;
}

.zj_p_caozuo ul li i.icon {
  font-size: 26px;
}

.zj_p_caozuo ul li.c1 i.icon {
  font-size: 20px;
  color: #686868;
}

.zj_p_caozuo ul li.c2 i.icon {
  color: #13d1be;
}

.zj_p_caozuo ul li.c3 i.icon {
  color: #4375e4;
}

.zj_p_caozuo ul li span.sm {
  font-size: 12px;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 7px;
  line-height: 12px;
  color: #999;
}

.zj_p_caozuo ul li span.num {
  font-size: 14px;
}

// .zj_p_caozuo ul li span.num em {
//   font-size: 20px;
//   color: #00d4af;
//   font-weight: normal;
// }


.ks_list_kk {
  border: #e3e3e3 1px solid;
  padding-bottom: 10px;
}

.zj_kk {
  width: 98%;
  margin: 0px auto;
}

.zj_ti_kk {
  margin-top: 20px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  display: block;
  clear: both;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}

.zj_ti_kk:hover {
  border: 1px solid #1abb9c;
}

.zj_ti_kk button.ti_jc_bn {
  position: absolute;
  right: 4px;
  top: 4px;
}

.zj_ti_kk button.ti_jc_bn:hover {
  background-color: #d9534f;
  color: #fff;
  border: 1px solid #d9534f;
}

.zj_ti_kk span.ti_xh {
  display: inline-block;
  background-color: #1abb9c;
  line-height: 120%;
  font-size: 12px;
  border: 1px solid #1abb9c;
  position: absolute;
  top: 0px;
  border-radius: 5px;
  left: 0px;
  color: #fff;
  padding-left: 5px;
  padding-right: 5px;
}

.zj_ti_kk span.ti_xh {}

.zj_ti_sx {
  background-color: #efefef;
  border-top: 1px solid #ddd;
  line-height: 45px;
  height: 48px;
  position: relative;
}

.zj_ti_sx span.s_left {
  float: left;
  padding-left: 10px;
}

.zj_ti_sx span.s_left span {
  padding-right: 5px;
  padding-left: 5px;
  color: #666;
}

.zj_ti_sx span.s_left span font {
  padding-right: 5px;
  padding-left: 5px;
  color: #333;
}

.zj_ti_sx span.s_right {
  float: right;
  padding-right: 10px;
}

.zj_ti_sx span.s_right i {
  padding-right: 3px;
}

.zj_ti_sx span.s_right span.btjx {
  display: inline-block;
  padding-right: 10px;
  padding-left: 10px;
  position: absolute;
  top: -2px;
  bottom: 0px;
  z-index: 10;
  right: 130px;
  line-height: 50px;
  color: #06C;
}

.zj_ti_sx span.s_right span.btjx:hover {
  cursor: pointer;
  color: #09C;
}

.zj_ti_sx span.s_right span.active {
  display: inline-block;
  padding-right: 10px;
  padding-left: 10px;
  position: absolute;
  top: -2px;
  bottom: 0px;
  z-index: 10;
  right: 230px;
  background-color: #FFFFFF;
  border: #1abb9c 1px solid;
  border-top: none;
  line-height: 50px;
  color: #1abb9c;
}

.searchbox .l {
  width: 55px !important;
}

.zj_btxx {
  display: block;
  clear: both;
  border-bottom: 1px dashed #dfdfdf;
  padding-bottom: 10px;
}

.zj_btxx .d_left {
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
}

.zj_btxx .d_left em {
  font-size: 14px;
  padding-left: 10px;
}

.zj_btxx .d_left em span {
  font-weight: bold;
  color: #f00;
  padding-left: 3px;
  padding-right: 3px;
}

.zj_btxx .d_right {
  float: right;
  margin-right: 10px;
}

.zj_btxx .d_right .icon {
  color: #2aad67;
}

.zj_btxx .d_left .yxtx {
  font-size: 14px;
  font-weight: normal;
  background-color: #ddf5e8;
  border: 1px solid #2aad67;
  padding: 1px 5px;
  border-radius: 4px;
  margin-right: 5px;
}


.ks_name_01 span {
  background-color: #2496ff;
  color: #fff;
  font-size: 12px;
  padding: 4px 5px;
  border-radius: 0px 0px 5px;
}



.wbk_serach01 {
  width: 100%;
  height: 35px;
  line-height: 35px;
  border-radius: 5px;
  border: #CCCCCC 1px solid;
  padding-left: 5px;
  padding-right: 5px;
}


/deep/.el-dialog__header {
  height: 42px;
  line-height: 42px;
  padding: 0 80px 0 20px;
  background: linear-gradient(to right, #2aad67, #2496ff) !important;
  color: #fff;
  font-size: 14px;
}

/deep/.el-dialog__body {
  padding: 0;
}

/deep/.el-dialog__title {
  color: #fff;
  font-size: 14px;
  height: 42px;
  line-height: 42px;
}

/deep/.el-dialog__headerbtn {
  position: absolute;
  top: 14px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
  color: #333;

  i {
    color: #333;
    font-weight: bold;
  }
}

.tc_xzxx ul li {
  width: 49%;
}

.zj_nr_kk {
  /* min-height: 500px; */
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.btn-info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}

.btn-success {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
}



.zj_p_caozuo {
  position: fixed;
  right: 10px;
  bottom: 80px;
  z-index: 1000;
}

.zj_p_caozuo ul li {
  width: 60px;
  height: 60px;
  text-align: center;
  border-radius: 50%;
  background-color: #fff;
  background: rgba(255, 255, 255, 0.85);
  margin-bottom: 10px;
  line-height: 48px;
  border: 1px solid #dfdfdf;
  position: relative;
  cursor: pointer;
}

.zj_p_caozuo ul li i.icon {
  font-size: 26px;
}

.zj_p_caozuo ul li.c1 i.icon {
  font-size: 20px;
  color: #686868;
}

.zj_p_caozuo ul li.c2 i.icon {
  color: #13d1be;
}

.zj_p_caozuo ul li.c3 i.icon {
  color: #4375e4;
}

.zj_p_caozuo ul li span.sm {
  font-size: 12px;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 7px;
  line-height: 12px;
  color: #999;
}

.zj_p_caozuo ul li span.num {
  font-size: 14px;
}

// .zj_p_caozuo ul li span.num em {
//   font-size: 20px;
//   color: #00d4af;
//   font-weight: normal;
// }


.ks_list_kk {
  border: #e3e3e3 1px solid;
  padding-bottom: 10px;
}

.zj_kk {
  width: 98%;
  margin: 0px auto;
}

.zj_ti_kk {
  margin-top: 20px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  display: block;
  clear: both;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}

.zj_ti_kk:hover {
  border: 1px solid #1abb9c;
}

.zj_ti_kk button.ti_jc_bn {
  position: absolute;
  right: 4px;
  top: 4px;
}

.zj_ti_kk button.ti_jc_bn:hover {
  background-color: #d9534f;
  color: #fff;
  border: 1px solid #d9534f;
}

.zj_ti_kk span.ti_xh {
  display: inline-block;
  background-color: #1abb9c;
  line-height: 120%;
  font-size: 12px;
  border: 1px solid #1abb9c;
  position: absolute;
  top: 0px;
  border-radius: 5px;
  left: 0px;
  color: #fff;
  padding-left: 5px;
  padding-right: 5px;
}

.zj_ti_kk span.ti_xh {}

.zj_ti_sx {
  background-color: #efefef;
  border-top: 1px solid #ddd;
  line-height: 45px;
  height: 48px;
  position: relative;
}

.zj_ti_sx span.s_left {
  float: left;
  padding-left: 10px;
}

.zj_ti_sx span.s_left span {
  padding-right: 5px;
  padding-left: 5px;
  color: #666;
}

.zj_ti_sx span.s_left span font {
  padding-right: 5px;
  padding-left: 5px;
  color: #333;
}

.zj_ti_sx span.s_right {
  float: right;
  padding-right: 10px;
}

.zj_ti_sx span.s_right i {
  padding-right: 3px;
}

.zj_ti_sx span.s_right span.btjx {
  display: inline-block;
  padding-right: 10px;
  padding-left: 10px;
  position: absolute;
  top: -2px;
  bottom: 0px;
  z-index: 10;
  right: 130px;
  line-height: 50px;
  color: #06C;
}

.zj_ti_sx span.s_right span.btjx:hover {
  cursor: pointer;
  color: #09C;
}

.zj_ti_sx span.s_right span.active {
  display: inline-block;
  padding-right: 10px;
  padding-left: 10px;
  position: absolute;
  top: -2px;
  bottom: 0px;
  z-index: 10;
  right: 230px;
  background-color: #FFFFFF;
  border: #1abb9c 1px solid;
  border-top: none;
  line-height: 50px;
  color: #1abb9c;
}

.searchbox .l {
  width: 55px !important;
}

.zj_btxx {
  display: block;
  clear: both;
  border-bottom: 1px dashed #dfdfdf;
  padding-bottom: 10px;
}

.zj_btxx .d_left {
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
}

.zj_btxx .d_left em {
  font-size: 14px;
  padding-left: 10px;
}

.zj_btxx .d_left em span {
  font-weight: bold;
  color: #f00;
  padding-left: 3px;
  padding-right: 3px;
}

.zj_btxx .d_right {
  float: right;
  margin-right: 10px;
}

.zj_btxx .d_right .icon {
  color: #2aad67;
}

.zj_btxx .d_left .yxtx {
  font-size: 14px;
  font-weight: normal;
  background-color: #ddf5e8;
  border: 1px solid #2aad67;
  padding: 1px 5px;
  border-radius: 4px;
  margin-right: 5px;
}

.ks_name_01 span {
  background-color: #2496ff;
  color: #fff;
  font-size: 12px;
  padding: 4px 5px;
  border-radius: 0px 0px 5px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #fff;
}

.content {
  /* 内容区域样式 */
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.serial-number {
  background-color: #079a4d;
  position: absolute;
  top: 0px;
  left: 0px;
  line-height: 100%;
  padding: 1px 5px;
  border-radius: 0px 0px 5px 0px;
  color: #fff;
}

.sj_yl_ti_nr01 {
  padding-top: 40px;
  position: relative;
}

.zj_p_caozuo ul li.c2 {
    background-color: #f96900;
    background-image: linear-gradient(to bottom, #ff7c1c , #f96900);
    color: #fff;
    border: 1px solid #fd9345;
    
    span em{
      font-size: 20px;
    }
    .sm{
      color: #fff;
      font-size: 12px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/examinationReport.vue